export default __webpack_public_path__ + "static/media/icon_info-circle.93bc70b0.svg";